import { SvgCurve, SvgTxt, MaterialRecord, MaterialSvg } from "../components/DrawMtrlCurve";

function ConcCurve(mtrl: MaterialRecord, svg: MaterialSvg): [SvgCurve[], SvgTxt[]] {
  //TODO: not hardcoded positon in array
  const maxS = 20; //mtrl.valObj["compression"].value / 1e6;
  const EpsC2 = 2; //mtrl.valObj["compressiveStrain2"].value * 1e3;
  const EpsCu2 = 3.5; //mtrl.valObj["ultimateCompressiveStrain2"].value * 1e3;
  const n = 2; //mtrl.valObj["n"].value;

  const scaleW = svg.max.x / EpsCu2;
  const scaleH = svg.max.y / maxS;

  // stress-strain curve --------------------------------

  let curve1: SvgCurve = {
    stroke: "red",
    width: "1",
    dash: "",
    data: "",
  };

  curve1.data = "M" + svg.origo.x.toString() + "," + svg.origo.y.toString() + " ";

  const de = EpsC2 / 10;

  let s_old = 0;
  for (let i = 1; i <= 10; i++) {
    let s = maxS * (1 - Math.pow(1 - (de * i) / EpsC2, n));
    let ds = s - s_old;
    s_old = s;
    curve1.data += "l" + (de * scaleW).toString() + "," + (-ds * scaleH).toString();
  }

  curve1.data += "l" + ((EpsCu2 - EpsC2) * scaleW).toString() + ",0";

  // 'fck'-line  --------------------------------

  let curve2: SvgCurve = {
    stroke: "black",
    width: "1",
    dash: "5,5",
    data: "",
  };

  curve2.data = "M" + (svg.origo.x - 5).toString() + "," + (svg.origo.y - maxS * scaleH).toString() + " ";
  curve2.data += "l" + (EpsC2 * scaleW + 5).toString() + ",0";

  // 'eps_c2'-line  --------------------------------

  let curve3: SvgCurve = {
    stroke: "black",
    width: "1",
    dash: "5,5",
    data: "",
  };

  curve3.data = "M" + (svg.origo.x + EpsC2 * scaleW).toString() + "," + (svg.origo.y + 5).toString() + " ";
  curve3.data += "l" + "0," + (-(maxS * scaleH + 5)).toString();

  // 'eps_cu2'-line  --------------------------------

  let curve4: SvgCurve = {
    stroke: "black",
    width: "1",
    dash: "5,5",
    data: "",
  };

  curve4.data = "M" + (svg.origo.x + EpsCu2 * scaleW).toString() + "," + (svg.origo.y + 5).toString() + " ";
  curve4.data += "l" + "0," + (-(maxS * scaleH + 5)).toString();

  //---- collect curves -----------------

  let curves = [curve1, curve2, curve3, curve4];

  //---- texts -----------------

  let pad = 0;
  if (EpsCu2 - EpsC2 < 0.4) pad = -30;

  let txts: SvgTxt[] = [
    {
      x: (svg.origo.x + EpsC2 * scaleW + pad).toString(),
      y: (svg.origo.y + 20).toString(),
      style: {
        fontSize: "30px",
        fontStyle: "italic",
      },
      text: "&epsilon;",
    },
    {
      x: (svg.origo.x + 9 + EpsC2 * scaleW + pad).toString(),
      y: (svg.origo.y + 25).toString(),
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "c2",
    },
    {
      x: (svg.origo.x + EpsCu2 * scaleW).toString(),
      y: (svg.origo.y + 20).toString(),
      style: {
        fontSize: "30px",
        fontStyle: "italic",
      },
      text: "&epsilon;",
    },
    {
      x: (svg.origo.x + 9 + EpsCu2 * scaleW).toString(),
      y: (svg.origo.y + 25).toString(),
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "cu2",
    },
    {
      x: (svg.origo.x - 30).toString(),
      y: (svg.origo.y - maxS * scaleH).toString(),
      style: {
        fontSize: "20px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "f",
    },
    {
      x: (svg.origo.x - 25).toString(),
      y: (svg.origo.y + 5 - maxS * scaleH).toString(),
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "cc",
    },
  ];

  return [curves, txts];
}

export default ConcCurve;
